import docsTocIcon from "../../../../content/blog/assets/docs-toc-icon.png";
import docsTocScreenshot from "../../../../content/blog/assets/docs-toc-screenshot.png";
import * as React from 'react';
export default {
  docsTocIcon,
  docsTocScreenshot,
  React
};